import styled from 'styled-components';
import { animated } from 'react-spring';
import { device } from '../../../styles/devices';
import type { ThemeProps } from '../../../types';

export const ModalContainer = styled(animated.section)`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: block;
  background-color: ${(props: { theme: ThemeProps }) => props.theme.sys.color.canvas.default};
  padding: 80px 30px;
  margin: auto;
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  z-index: 990;
  @media ${device.tablet} {
    align-self: center;
    top: initial;
    bottom: initial;
    max-height: 100vh;
    height: 100vh;
    width: 100%;
    padding: 26px 81px;
  }
`;

export const ContentContainer = styled.div`
  margin-bottom: 26px;
`;

export const ButtonContainer = styled.div`
  position: absolute;
  top: 30px;
  right: 30px;
  @media ${device.tablet} {
    top: 39px;
    right: 49px;
  }
  button {
    background: transparent;
    height: 45px;
    width: 45px;
    padding: 0;
    border: 1px solid
      ${(props: { theme: ThemeProps }) => props.theme.sys.color.surface.neutral[100]};
    border-radius: 50%;
    position: relative;
    z-index: 1000;
    position: relative;
    cursor: pointer;
  }
`;
